// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';

// import Swiper styles
// import 'swiper/css/bundle';

export default class initSwiper {
  constructor() {
    this._isInit = true;
    this.addEvents()

    var swiper = new Swiper('.js-swiper', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    var supporterSlide = new Swiper('.js-supporterSlide', {
      direction: 'horizontal',
      freeMode: false,
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 10,
      },
      slidesPerView: 'auto',
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      threshold: 5,
    });

    var topSwiper = new Swiper('.js-topSwiper', {
      // lazy: true,
      direction: 'vertical',
      keyboard: {
        enabled: true,
      },
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 10,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      simulateTouch: false,
      speed: 750,
    });

    topSwiper.on('slideChangeTransitionStart', () => {
    });

    topSwiper.on('slideChangeTransitionEnd', () => {
    });

    // "forward" direction only
    topSwiper.on('slideNextTransitionStart', () => {
      topSwiper.$el.find('.swiper-slide-active').removeClass('transitionEnd').addClass('transition');
      topSwiper.$el.removeClass('slide'+topSwiper.previousIndex).addClass('slide'+topSwiper.activeIndex);

      if (topSwiper.activeIndex == 1) {
        $(".b_transit_img").addClass('animate');
      } else {
        $(".b_transit_img").removeClass('animate');
      }
    });

    // "forward" direction only
    topSwiper.on('slideNextTransitionEnd', () => {
      topSwiper.$el.find('.swiper-slide-active').removeClass('transition').addClass('transitionEnd');
    });

    // "backward" direction only
    topSwiper.on('slidePrevTransitionStart', () => {
      topSwiper.$el.find('.swiper-slide-next').removeClass('transitionEnd')
      topSwiper.$el.removeClass('slide'+topSwiper.previousIndex).addClass('slide'+topSwiper.activeIndex);
      $(".b_transit_img").removeClass('animate');
    });

    // "backward" direction only
    topSwiper.on('slidePrevTransitionEnd', () => {
      topSwiper.$el.find('.swiper-slide-active').addClass('transitionEnd');
    });

    // slide0 -> slide1 transition
    const b_speed = 1000/29.97; //アニメーションフレーム速度
    let b_count = -1;
    function b_transit() {
      if (b_count < 12) {
        $(".b_transit_img").css("background-position", "0 " + b_count * 8.333 + "%");
      } else {
        $(".b_transit_img").css("background-position", "0 " + (100 + b_count / 4) + "%");
      }
      b_count++;
      if (3 < b_count && b_count < 8) {
        setTimeout(b_transit, b_speed * 2);
      } else if (b_count < 40) {
        setTimeout(b_transit, b_speed);
      } else {
        b_count = -1;
      }
    }
  }

  addEvents() {

  }
}
